export const getSvgFlag = (countryCode, res = '4x3') => {
  return require('../resources/styles/flags/' +
    res +
    '/' +
    countryCode.toLowerCase() +
    '.svg');
};
